import { render, staticRenderFns } from "./MultiNPC.vue?vue&type=template&id=70a4cf74&scoped=true"
import script from "./MultiNPC.vue?vue&type=script&lang=js"
export * from "./MultiNPC.vue?vue&type=script&lang=js"
import style0 from "./MultiNPC.vue?vue&type=style&index=0&id=70a4cf74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4cf74",
  null
  
)

export default component.exports